<ul class="navbar-nav">
  <li class="nav-item dropdown position-static active">
       <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Home</a>
       <div class="dropdown-menu">
         <!-- app-mega-menu start -->
         <app-mega-menu></app-mega-menu>
         <!-- app-mega-menu end  -->
       </div> <!-- /.dropdown-menu -->
   </li>
   <li class="nav-item dropdown">
       <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Portfolio</a>
       <ul class="dropdown-menu">
         <li>
           <a [routerLink]="['/portfolio-v1']" class="dropdown-item">Classic Style</a>
         </li>
         <li>
           <a [routerLink]="['/portfolio-v2']" class="dropdown-item">Grid 2 Columns</a>
         </li>
         <li>
           <a [routerLink]="['/portfolio-v3']" class="dropdown-item">Grid 3 Columns</a>
         </li>
         <li>
           <a [routerLink]="['/portfolio-v4']" class="dropdown-item">Gallery Slider</a>
         </li>
         <li>
           <a [routerLink]="['/portfolio-v5']" class="dropdown-item">Grid Single</a>
       </li>
       <li>
           <a [routerLink]="['/portfolio-details']" class="dropdown-item">Classic Details</a>
       </li>
       </ul> <!-- /.dropdown-menu -->
   </li>
   <li class="nav-item dropdown mega-dropdown-md">
     <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Pages</a>
         <ul class="dropdown-menu">
           <li>
             <div class="row">
               <div class="col-lg-3">
                 <div class="menu-column">
                   <h6 class="mega-menu-title">About Us</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/about-us-cs']" class="dropdown-item">Customer Support</a></li>
                     <li><a [routerLink]="['/about-us-event']" class="dropdown-item">Event Organiser</a></li>
                     <li><a [routerLink]="['/about-us-management']" class="dropdown-item">Project Management</a></li>
                     <li><a [routerLink]="['/about-us-doc']" class="dropdown-item">Documentation</a></li>
                   </ul>
                   <h6 class="mega-menu-title">Team</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/team-v1']" class="dropdown-item">Team Version 01</a></li>
                     <li><a [routerLink]="['/team-v2']" class="dropdown-item">Team Version 02</a></li>
                     <li><a [routerLink]="['/team-details']" class="dropdown-item">Team Details</a></li>
                   </ul>
                 </div>
               </div>
               <div class="col-lg-3">
                 <div class="menu-column">
                   <h6 class="mega-menu-title">Pricing</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/pricing-cs']" class="dropdown-item">Customer Support</a></li>
                     <li><a [routerLink]="['/pricing-event']" class="dropdown-item">Event Organiser</a></li>
                     <li><a [routerLink]="['/pricing-management']" class="dropdown-item">Project Management</a></li>
                   </ul>
                   <h6 class="mega-menu-title">Contact Us</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/contact-us-cs']" class="dropdown-item">Customer Support</a></li>
                     <li><a [routerLink]="['/contact-us-event']" class="dropdown-item">Event Organiser</a></li>
                     <li><a [routerLink]="['/contact-us-management']" class="dropdown-item">Project Management</a></li>
                     <li><a [routerLink]="['/contact-us-doc']" class="dropdown-item">Documentation</a></li>
                   </ul>
                 </div>
               </div>
               <div class="col-lg-3">
                 <div class="menu-column">
                   <h6 class="mega-menu-title">Services</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/services-v1']" class="dropdown-item">Service Version 01</a></li>
                     <li><a [routerLink]="['/services-v2']" class="dropdown-item">Service Version 02</a></li>
                     <li><a [routerLink]="['/services-v3']" class="dropdown-item">Service Version 03</a></li>
                     <li><a [routerLink]="['/services-v4']" class="dropdown-item">Service Version 04</a></li>
                     <li><a [routerLink]="['/service-details']" class="dropdown-item">Service Details</a></li>
                   </ul>
                   <h6 class="mega-menu-title">Feature</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/solution-management']" class="dropdown-item">Our Solution</a></li>
                   <li><a [routerLink]="['/product-cs']" class="dropdown-item">Product Feature</a></li>
                   <li><a [routerLink]="['/feature-cs']" class="dropdown-item">Our Features</a></li>
                   </ul>
                 </div>
               </div>
               <div class="col-lg-3">
                 <div class="menu-column">
                   <h6 class="mega-menu-title">Others</h6>
                   <ul class="mega-dropdown-list">
                     <li><a [routerLink]="['/faq']" class="dropdown-item">FAQ</a></li>
                     <li><a [routerLink]="['/faq-details']" class="dropdown-item">Faq Details</a></li>
                     <li><a [routerLink]="['/terms-condition']" class="dropdown-item">Terms & Condition</a></li>
                     <li><a [routerLink]="['/login']" class="dropdown-item">Login</a></li>
                     <li><a [routerLink]="['/register']" class="dropdown-item">Signup</a></li>
                     <li><a [routerLink]="['/404']" class="dropdown-item">404 Error</a></li>
                   </ul>
                 </div>
               </div>
             </div>
           </li>
         </ul>
     </li>
   <li class="nav-item dropdown">
       <a class="nav-link dropdown-toggle" data-bs-auto-close="outside" [routerLink]="['./']" data-bs-toggle="dropdown">Blogs</a>
       <ul class="dropdown-menu">
         <li class="dropdown-submenu dropdown">
           <a [routerLink]="['./']" class="dropdown-item dropdown-toggle" data-bs-auto-close="outside" data-bs-toggle="dropdown">Third Level Menu</a>
           <ul class="dropdown-menu">
             <li><a [routerLink]="['./']" class="dropdown-item">Menu Level 01</a></li>
               <li><a [routerLink]="['./']" class="dropdown-item">Menu Level 02</a></li>
               <li><a [routerLink]="['./']" class="dropdown-item">Menu Level 03</a></li>
             </ul>
         </li>
         <li>
           <a [routerLink]="['/blog-v1']" class="dropdown-item">Blog Version 01</a>
         </li>
         <li>
           <a [routerLink]="['/blog-v2']" class="dropdown-item">Blog Version 02</a>
         </li>
         <li>
           <a [routerLink]="['/blog-v3']" class="dropdown-item">Blog Version 03</a>
         </li>
         <li>
           <a [routerLink]="['/blog-v4']" class="dropdown-item">Blog Version 04</a>
         </li>
         <li>
           <a [routerLink]="['/blog-details']" class="dropdown-item">Blog Details</a>
       </li>
       </ul> <!-- /.dropdown-menu -->
   </li>
   <li class="nav-item dropdown">
       <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Docs</a>
       <ul class="dropdown-menu">
         <li>
           <a [routerLink]="['/doc-fullwidth']" class="dropdown-item">Full Width</a>
         </li>
         <li>
           <a [routerLink]="['/doc-fullwidth-banner']" class="dropdown-item">Full Width Banner</a>
         </li>
         <li>
           <a [routerLink]="['/doc-box']" class="dropdown-item">Doc Box</a>
         </li>
         <li>
           <a [routerLink]="['/doc-box-banner']" class="dropdown-item">Doc Box with Banner</a>
         </li>
         <li>
           <a [routerLink]="['/changelog']" class="dropdown-item">Changelog <code class="text-danger">**</code></a>
         </li>
       </ul> <!-- /.dropdown-menu -->
   </li>
</ul>
